import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/Faces_of_Talent_WhoWeAre.png";
import {
  Users,
  // Building2,
  HandHeart,
  MapPin,
  Phone,
  Mail,
  Video,
  Clock,
  Target,
  // ChevronRight,
  DollarSign,
  Shield,
} from "lucide-react";
import who from "../assets/who_we_serve_banner.jpg";
import work from "../assets/WorkforceDevelopment-Hero-Image.jpg";
import people from "../assets/people.jpg";
import workDev from "../assets/workforce-dev.jpg";
import { regions, jobseekerServices } from "../data/whoWeServeData";
// import Community from "./Community";
// import placeholder from "../assets/partner.png";

const WhoWeServe = () => {
  const navigate = useNavigate();
  // const [isJobSeekerModalOpen, setIsJobseekerModalOpen] = useState(false);
  // const [isMODOCModalOpen, setIsMODOCModalOpen] = useState(false);
  // const [isNewEmpModalOpen, setIsNewEmpModalOpen] = useState(false);
  // const [isExistingEmpModalOpen, setIsExistingEmpModalOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expandedCards, setExpandedCards] = useState({
    stlJobseeker: false,
    modocJobseeker: false,
    newEmployer: false,
    existingEmployer: false,
  });

  // Smooth scroll to section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Toggle function for Read More/Read Less
  const toggleCard = (cardKey) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardKey]: !prev[cardKey],
    }));
  };

  // Enhanced benefits with specific tax credits and bonding program
  const enhancedBenefits = [
    {
      icon: <Users className="w-8 h-8" />,
      title: "Access to a Broader Talent Pool",
      description:
        "Many fair chance hires are eager to prove themselves and demonstrate strong commitment, loyalty, and work ethic.",
    },
    {
      icon: <DollarSign className="w-8 h-8" />,
      title: "Work Opportunity Tax Credit (WOTC)",
      description:
        "A federal tax credit for hiring individuals from certain targeted groups, including individuals with felony records. This credit can provide up to $2,400 (or more) per qualified employee.",
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Federal Bonding Program",
      description:
        "Free, no-cost fidelity bonds to employers hiring individuals with justice involvement. These bonds protect against potential losses due to employee dishonesty and offer added peace of mind.",
    },
  ];

  return (
    <div className="font-['corporate-s'] min-h-screen text-[#2b2b2b]">
      {/* Header */}
      {/* Header */}
      <header className="relative">
        <img
          src={who}
          alt="Serve background"
          className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover"
        />
        <div className="absolute inset-0 bg-blue-900 opacity-60"> </div>
        <div className="absolute inset-0 flex items-center justify-center p-4">
          <h1 className="text-[2rem] sm:text-[3rem] md:text-[4.25rem] font-bold font-['corporate-s'] text-[#FFFFFF] my-4 text-center">
            Who We Serve
          </h1>
        </div>
      </header>

      {/* COLOR BLOCK SECTION */}
      <section className="relative bg-gray-200 py-16 h-[50px] md:h-[150px]">
        {/* OVERLAPPING CONTENT BOX */}
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center px-6">
          <div className="bg-white relative p-6 md:px-6 md:w-[300px] shadow-xl mx-auto max-w-sm h-lg md:max-w-xl">
            <h2 className="text-xl sm:text-lg md:text-xl font-bold font-['corporate']  mb-4 text-[#003DA5] text-center">
              Justice-involved Jobseekers
            </h2>
            <hr className="w-full h-1 my-4 mx-auto bg-gray-300 border-0" />
            <h2 className="text-xl sm:text-lg md:text-xl font-bold font-['corporate']  mb-4 text-[#003DA5] text-center">
              New or Existing Fair Chance Employers
            </h2>
            <hr className="w-full h-1 my-4 mx-auto bg-gray-300 border-0" />
            <h2 className="text-xl sm:text-lg md:text-xl font-bold font-['corporate']  mb-4 text-[#003DA5] text-center">
              Community Referral Partners
            </h2>
          </div>
        </div>
      </section>
      {/* COLOR BLOCK SECTION */}
      {/* <section className="relative bg-gray-200 py-16 md:h-[150px]">
        {/* OVERLAPPING CONTENT BOX *
        <div className="absolute md:relative z-20 top-1/2 md:top-auto left-1/2 md:center-auto transform md:transform-none -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl px-6 md:px-40">
          <div className="bg-white p-6 md:p-10 font-['farnham-display'] shadow-xl">
           <h2 class="text-xl sm:text-lg md:text-2xl font-bold mb-4 text-[#003DA5] text-center">
        Justice-involved Jobseekers
      </h2>
      <hr class="w-full h-1 my-4 mx-auto bg-gray-300 border-0" />
      <h2 class="text-xl sm:text-lg md:text-2xl font-bold mb-4 text-[#003DA5] text-center">
        New or Existing Fair Chance Employers
      </h2>
      <hr class="w-full h-1 my-4 mx-auto bg-gray-300 border-0" />
      <h2 class="text-xl sm:text-lg md:text-2xl font-bold mb-4 text-[#003DA5] text-center">
        Community Referral Partners
      </h2>

          </div>
        </div>
      </section> */}

      <section className="pt-40 pb-12">
        <div className="max-w-5xl h-55 mx-auto px-6 sm:px-10 md:px-16 lg:px-20 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            { title: "Jobseekers", color: "#003DA5", id: "jobseekers-section" },
            { title: "Employers", color: "#FFC72C", id: "employers-section" },
            { title: "Partners", color: "#668ac9", id: "partners-section" },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white p-6 flex flex-col justify-center items-center shadow-lg/30 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-l-4 cursor-pointer"
              onClick={() => scrollToSection(item.id)}
              // onClick={() => (window.location.href = `#${item.id}`)}
              style={{ borderColor: item.color }}
            >
              <h3
                className="text-3xl sm:text-xl md:text-4xl lg:text-5xl font-bold font-['corporate-s']"
                style={{ color: item.color }}
              >
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </section>

      <div className=" px-4 md:px-0">
        {/* Jobseekers Section */}
        <section id="jobseekers-section" className="bg-white">
          <div className="mx-auto max-w-7xl md:pr-20">
            <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
              <div className="text-left mt-20 md:col-start-2 md:col-span-5 flex flex-col sm:flex-row items-center py-3">
                <h2 className="text-5xl font-bold font-[corporate-s] text-[#003DA5]">
                  Jobseekers
                </h2>
                <p className="text-xl md:text-3xl text-center leading-tight font-['farnham-display'] text-[#2b2b2b] md:pl-6 mt-2">
                  Are you a justice-involved jobseeker?
                </p>
              </div>
              {/* <div className="bg-[#E2E2E2FF] justify-center col-span-1 my-10 md:col-start-2 md:col-span-6 py-3">
                
                <div className="border-l-6  border-[#FFC72C] ml-6 pl-4 md:pr-20">
                
                  <div className="font-['corporate-s'] text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed text-[#2b2b2b]">
                    <p>
                      We serve the community through supporting justice-involved
                      jobseekers, in both STL community jobseekers and MO DOC
                      Pre-Release participants in 4 regions around Missouri.
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>

          <div className="grid py-8 px-0 place-items-center bg-[#ffff]">
            <div className="flex flex-col md:flex-row items-center gap-6 bg-[#f0f0f0] md:h-full">
              <div className="md:w-1/2 h-full relative pr-2">
                {/* Image container (on the right on large screens) */}
                <img
                  src={workDev}
                  alt="Workforce Development"
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Yellow Line + Text */}
              <div className="md:w-1/2 relative ">
                <div className="pl-6 pt-10 pb-10 ">
                  <p className="text-base md:text-xl lg:text-md xl:text-xl text-left my-4 px-2 font-['corporate-s'] leading-relaxed border-l-6 border-[#FFD700]">
                    We serve the community through supporting justice-involved
                    jobseekers, in both STL community jobseekers and MO DOC
                    Pre-Release participants in 4 regions around Missouri. We
                    recognize that individuals with criminal records often face
                    significant barriers to employment—even after they've paid
                    their debt to society and are ready to move forward. At SLU
                    TWA, we believe in the power of second chances.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className=" flex flex-col md:px-20  px-0 space-y-8">
            {/* <div
              // onClick={() => setIsJobseekerModalOpen(true)}
              className="bg-[#003DA5] text-white justify-center p-6 rounded-lg"
            >
              <h3 className="text-2xl font-bold text-center mb-4">
                STL Community Jobseeker
              </h3>
              <div
                className={`transition-all duration-500 ease-in-out ${
                  expandedCards.stlJobseeker
                    ? "max-h-[1000px] opacity-100"
                    : "max-h-20 opacity-75"
                }`}
              >
                <p className="md:text-lg text-md lg:text-lg mb-4 text-[#fff] font-['corporate-s']">
                  {expandedCards.stlJobseeker
                    ? "We are pleased to announce that in St. Louis, thanks to a generous grant from the St. Louis County Port Authority and funding from the Bob Barker Foundation, we work with justice-involved people who self-refer or find us through our community partners to prepare and connect them with fair chance employers."
                    : "We are pleased to announce that in St. Louis, thanks to a generous grant from the St. Louis County Port Authority and funding from the Bob Barker Foundation, we work with justice-involved people who self-refer or find us through our community partners to prepare and connect them with fair chance employers.".slice() +
                      "..."}
                </p>
                {expandedCards.stlJobseeker && (
                  <>
                    <div className="bg-white p-6">
                      <h4 className="md:text-lg text-md lg:text-xl font-bold mb-4 text-[#003DA5] font-['corporate-s']">
                        How it works
                      </h4>
                      <p className="mb-3 text-[#2b2b2b] font-['corporate-s'] md:text-lg text-md lg:text-lg">
                        Jobseeker services can include:
                      </p>
                      <ul className="space-y-2 mb-4 font-['corporate-s']">
                        {jobseekerServices.map((service, index) => (
                          <li key={index} className="flex items-start gap-2">
                            <div className="w-2 h-2 bg-[#003DA5] rounded-full mt-1.5 flex-shrink-0"></div>
                            <span className="md:text-lg text-md lg:text-lg text-[#2b2b2b]">
                              {service}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <p className="text-[#2b2b2b] font-regular font-['corporate-s'] md:text-lg text-md lg:text-lg">
                        TWA staff then connect jobseekers with employer partners
                        based on the best fit for both sides!
                      </p>
                    </div>

                    <div className="bg-[#fff] p-6 ">
                      <div className="flex items-center gap-2 mb-3">
                        <Phone className="w-5 h-5 text-[#00244D]" />
                        <span className="font-bold text-[#003DA5] font-['corporate-s'] md:text-lg text-md lg:text-xl">
                          Get Started
                        </span>
                      </div>
                      <p className="text-[#2b2b2b] mb-3 font-['corporate-s'] md:text-lg text-md lg:text-lg">
                        Individuals may enter their information on the wait list
                        or call and leave a message at{" "}
                        <strong>314-977-5498</strong> to be added to the wait
                        list.
                      </p>
                      <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
                        We review new referrals every Monday to give them a
                        projected timeline of when we are available to assist if
                        we cannot work with someone immediately.
                      </p>
                      <Link
                        to="/contact#stlouis"
                        className="inline-flex items-center gap-2 mt-4 bg-[#00244D]/70 text-white px-4 py-2 rounded-lg hover:bg-[#00244D] transition-colors text-sm"
                      >
                        <Mail className="w-4 h-4" />
                        STL Contact Info
                      </Link>
                    </div>
                  </>
                )}
              </div>
              <button
                onClick={() => toggleCard("stlJobseeker")}
                className="text-[#fff] text-center hover:underline mt-3 font-medium md:text-lg text-md lg:text-lg "
              >
                {expandedCards.stlJobseeker ? "Read Less" : "Read More"}
              </button>
            </div> */}
<div
  // onClick={() => setIsJobseekerModalOpen(true)}
  className="bg-[#003DA5] text-white justify-center p-6 rounded-lg"
>
  <h3 className="text-2xl font-bold text-center mb-4">
    STL Community Jobseeker
  </h3>

  <div
    className={`overflow-hidden transition-all duration-500 ease-in-out ${
      expandedCards.stlJobseeker
        ? "max-h-[1000px] opacity-100"
        : "max-h-20 opacity-75"
    }`}
  >
    <p className="md:text-lg text-md lg:text-lg mb-4 text-[#fff] font-['corporate-s']">
      {expandedCards.stlJobseeker
        ? "We are pleased to announce that in St. Louis, thanks to a generous grant from the St. Louis County Port Authority and funding from the Bob Barker Foundation, we work with justice-involved people who self-refer or find us through our community partners to prepare and connect them with fair chance employers."
        : "We are pleased to announce that in St. Louis, thanks to a generous grant from the St. Louis County Port Authority and funding from the Bob Barker Foundation, we work with justice-involved people who self-refer or find us through our community partners to prepare and connect them with fair chance employers." +
          "..."}
    </p>

    {expandedCards.stlJobseeker && (
      <>
        <div className="bg-white p-6">
          <h4 className="md:text-lg text-md lg:text-xl font-bold mb-4 text-[#003DA5] font-['corporate-s']">
            How it works
          </h4>
          <p className="mb-3 text-[#2b2b2b] font-['corporate-s'] md:text-lg text-md lg:text-lg">
            Jobseeker services can include:
          </p>
          <ul className="space-y-2 mb-4 font-['corporate-s']">
            {jobseekerServices.map((service, index) => (
              <li key={index} className="flex items-start gap-2">
                <div className="w-2 h-2 bg-[#003DA5] rounded-full mt-1.5 flex-shrink-0"></div>
                <span className="md:text-lg text-md lg:text-lg text-[#2b2b2b]">
                  {service}
                </span>
              </li>
            ))}
          </ul>
          <p className="text-[#2b2b2b] font-regular font-['corporate-s'] md:text-lg text-md lg:text-lg">
            TWA staff then connect jobseekers with employer partners
            based on the best fit for both sides!
          </p>
        </div>

        <div className="bg-[#fff] p-6 ">
          <div className="flex items-center gap-2 mb-3">
            <Phone className="w-5 h-5 text-[#00244D]" />
            <span className="font-bold text-[#003DA5] font-['corporate-s'] md:text-lg text-md lg:text-xl">
              Get Started
            </span>
          </div>
          <p className="text-[#2b2b2b] mb-3 font-['corporate-s'] md:text-lg text-md lg:text-lg">
            Individuals may enter their information on the wait list
            or call and leave a message at{" "}
            <strong>314-977-5498</strong> to be added to the wait
            list.
          </p>
          <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
            We review new referrals every Monday to give them a
            projected timeline of when we are available to assist if
            we cannot work with someone immediately.
          </p>
          <Link
            to="/contact#stlouis"
            className="inline-flex items-center gap-2 mt-4 bg-[#00244D]/70 text-white px-4 py-2 rounded-lg hover:bg-[#00244D] transition-colors text-sm"
          >
            <Mail className="w-4 h-4" />
            STL Contact Info
          </Link>
        </div>
      </>
    )}
  </div>
  <button
    onClick={() => toggleCard("stlJobseeker")}
    className="relative z-10 text-[#fff] text-center hover:underline mt-3 font-medium md:text-lg text-md lg:text-lg"
  >
    {expandedCards.stlJobseeker ? "Read Less" : "Read More"}
  </button>
</div>

            <div
              //  onClick={() => setIsMODOCModalOpen(true)}
              className="bg-gray-300 text-[#003DA5] justify-center p-6 rounded-lg"
            >
              <h3 className="text-2xl font-bold text-center mb-4">
                MO-DOC Pre-Release Participants
              </h3>
              <div
                className={`transition-all duration-500 ease-in-out ${
                  expandedCards.modocJobseeker
                    ? "max-h-[2000px] opacity-100"
                    : "max-h-20 opacity-75"
                } overflow-hidden`}
              >
                <p className="md:text-lg text-md lg:text-lg leading-relaxed mb-4 text-[#003DA5] font-['corporate-s']">
                  {expandedCards.modocJobseeker
                    ? "By engaging justice-involved jobseekers earlier, we can better prepare them for employment and reduce the stress of post-release job searching. Our video resume model allows participants to showcase their skills and readiness to employers before they leave incarceration, making the hiring process more seamless and efficient."
                    : "By engaging justice-involved jobseekers earlier, we can better prepare them for employment and reduce the stress of post-release job searching. Our video resume model allows participants to showcase their skills and readiness to employers before they leave incarceration, making the hiring process more seamless and efficient."
                        .slice
                        // 0,
                        // 100
                        () + "..."}
                </p>
                {expandedCards.modocJobseeker && (
                  <>
                    <div className="bg-white p-6 ">
                      <h4 className="md:text-lg text-md lg:text-xl font-bold mb-3 text-[#003DA5] font-['corporate-s']">
                        Partnership Facilities
                      </h4>
                      <p className="text-[#2b2b2b] mb-3 font-font-['corporate-s'] md:text-lg text-md lg:text-lg">
                        In partnership with the Missouri Department of
                        Corrections (MO DOC), SLU TWA works with jobseekers in
                        five correctional facilities, which include:
                      </p>
                      <div className="grid grid-cols-1 gap-2 md:text-lg text-md lg:text-lg font-['corporate-s']">
                        {[
                          "Bowling Green (NECC)",
                          "Farmington (FCC)",
                          "Pacific (MECC)",
                          "Vandalia (WERDCC)",
                          "Transition Center of St. Louis (TCSTL)",
                        ].map((facility, index) => (
                          <div key={index} className="flex items-center gap-2">
                            <MapPin className="w-4 h-4 text-[#003DA5]" />
                            <span className="text-[#2b2b2b] md:text-lg text-md lg:text-lg">
                              {facility}
                            </span>
                          </div>
                        ))}
                      </div>
                      <p className="text-[#2b2b2b] mt-3 md:text-lg text-md lg:text-lg font-['corporate-s']">
                        This collaboration with MO DOC has offered TWA the
                        opportunity to expand and prepare participants in these
                        institutions who are heading home not only to the St.
                        Louis Metropolitan Area, but also to Kansas City,
                        Springfield, and Columbia, Missouri.
                      </p>
                    </div>

                    <div className="bg-white p-6">
                      <h4 className="md:text-lg text-md lg:text-xl font-bold mb-3  text-[#003DA5] font-['corporate-s']">
                        How we work together
                      </h4>
                      <p className="text-[#2b2b2b] mb-4 font-['corporate-s'] md:text-lg text-md lg:text-lg">
                        Jobseekers pre-release services begin 90-120 days before
                        release and then continue the process after they are
                        home, with follow-up available for the year after
                        release. Pre-release services are centered around
                        evidence-based curriculum, which teach successful
                        reentry practices with real world applications.
                      </p>
                      <div className="space-y-3 mb-4">
                        <div className="flex items-start gap-2">
                          <Clock className="w-5 h-5 text-blue-600 mt-1" />
                          <div>
                            <p className="font-semibold  text-[#003DA5] font-['corporate-s'] md:text-lg text-md lg:text-lg">
                              Pre-Release (90-120 days before release)
                            </p>
                            <p className="text-[#2b2b2b] md:text-lg text-md lg:text-lg">
                              Evidence-based curriculum teaching successful
                              reentry practices with real world applications
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start gap-2">
                          <Target className="w-5 h-5 text-blue-600 mt-1" />
                          <div>
                            <p className="font-semibold  text-[#003DA5] font-['corporate-s'] md:text-lg text-md lg:text-lg">
                              Post-Release Services
                            </p>
                            <p className="text-[#2b2b2b] mb-2 font-['corporate-s'] md:text-lg text-md lg:text-lg">
                              Upon reentry it is the participants'
                              responsibility to contact the SLU TWA program and
                              arrange a meeting with an employment specialist.
                              Services include:
                            </p>
                            <ul className="space-y-1 md:text-lg text-md lg:text-lg font-['corporate-s']">
                              {jobseekerServices.map((service, index) => (
                                <li
                                  key={index}
                                  className="flex items-start gap-2"
                                >
                                  <div className="w-1.5 h-1.5 bg-[#003DA5] mt-1.5 flex-shrink-0"></div>
                                  <span className="text-[#2b2b2b]">
                                    {service}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-[#fff] p-6 ">
                      <h4 className="md:text-lg text-md lg:text-xl font-bold mb-3  text-[#003DA5] font-['corporate-s']">
                        Find your region
                      </h4>
                      <p className="text-[#2b2b2b] mb-3 font-['corporate-s'] md:text-lg text-md lg:text-lg ">
                        In our expansion areas, as we establish our footprint in
                        those communities, we are currently only able to work
                        with participants who began services with us
                        pre-release.
                      </p>
                      <p className="text-[#2b2b2b] mb-3 font-['corporate-s'] md:text-lg text-md lg:text-lg ">
                        If you are a participant in the program and ready to
                        begin post-release work, please contact the SLU TWA
                        contact in your region:
                      </p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        {regions.map((region, index) => (
                          <Link
                            key={index}
                            to={region.contact}
                            className="text-[#003DA5] font-medium hover:underline md:text-lg text-md lg:text-lg  font-['corporate-s']"
                          >
                            {region.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <button
                onClick={() => toggleCard("modocJobseeker")}
                className="text-[#003DA5] hover:underline mt-3 font-medium md:text-lg text-md lg:text-lg "
              >
                {expandedCards.modocJobseeker ? "Read Less" : "Read More"}
              </button>
            </div>
          </div>

          {/* <div className = "grid grid-cols-1 md:grid-cols-6 gap-3">
          <div className="md:col-start-1 md:col-span-3 col-span-1 justify-center space-y-6 gap-8">
            <div className="lg:grid-col-2 space-y-4 gap-8">
              <div 
             // onClick={() => setIsJobseekerModalOpen(true)} 
              className="bg-[#003DA5] text-white justify-center p-6">
                <h3 className="text-2xl font-bold text-center mb-4">STL Community Jobseeker</h3>
                <div className={`transition-all duration-500 ease-in-out ${expandedCards.stlJobseeker ? 'max-h-[1000px] opacity-100' : 'max-h-20 opacity-75'}`}>
                  <p className="md:text-lg text-md lg:text-lg mb-4 text-[#fff] font-['corporate-s']">
                    {expandedCards.stlJobseeker
                      ? "We are pleased to announce that in St. Louis, thanks to a generous grant from the St. Louis County Port Authority and funding from the Bob Barker Foundation, we work with justice-involved people who self-refer or find us through our community partners to prepare and connect them with fair chance employers."
                      : "We are pleased to announce that in St. Louis, thanks to a generous grant from the St. Louis County Port Authority and funding from the Bob Barker Foundation, we work with justice-involved people who self-refer or find us through our community partners to prepare and connect them with fair chance employers.".slice(0, 100) + "..."}
                  </p>
                  {expandedCards.stlJobseeker && (
                    <>
                      <div className="bg-white p-6 mb-4 shadow-sm">
                        <h4 className="md:text-lg text-md lg:text-xl font-bold mb-4 text-[#003DA5] font-['corporate-s']">
                          How it works
                        </h4>
                        <p className="mb-3 text-[#2b2b2b] font-['corporate-s'] md:text-lg text-md lg:text-lg">
                          Jobseeker services can include:
                        </p>
                        <ul className="space-y-2 mb-4 font-['corporate-s']">
                          {jobseekerServices.map((service, index) => (
                            <li key={index} className="flex items-start gap-2">
                              <div className="w-2 h-2 bg-[#53C3EE] rounded-full mt-1.5 flex-shrink-0"></div>
                              <span className="md:text-lg text-md lg:text-lg text-[#2b2b2b]">{service}</span>
                            </li>
                          ))}
                        </ul>
                        <p className="text-[#2b2b2b] font-regular font-['corporate-s'] md:text-lg text-md lg:text-lg">
                          TWA staff then connect jobseekers with employer partners
                          based on the best fit for both sides!
                        </p>
                      </div>

                      <div className="bg-[#f0f0f0]/80 p-6 rounded-lg shadow-sm">
                        <div className="flex items-center gap-2 mb-3">
                          <Phone className="w-5 h-5 text-[#00244D]" />
                          <span className="font-bold text-[#00244D] font-['corporate-s'] md:text-lg text-md lg:text-xl">
                            Get Started
                          </span>
                        </div>
                        <p className="text-[#2b2b2b] mb-3 font-['corporate-s'] md:text-lg text-md lg:text-lg">
                          Individuals may enter their information on the wait list
                          or call and leave a message at{" "}
                          <strong>314-977-5498</strong> to be added to the wait
                          list.
                        </p>
                        <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
                          We review new referrals every Monday to give them a
                          projected timeline of when we are available to assist if
                          we cannot work with someone immediately.
                        </p>
                        <Link
                          to="/contact#stlouis"
                          className="inline-flex items-center gap-2 mt-4 bg-[#00244D]/70 text-white px-4 py-2 rounded-lg hover:bg-[#00244D] transition-colors text-sm"
                        >
                          <Mail className="w-4 h-4" />
                          STL Contact Info
                        </Link>
                      </div>
                    </>
                  )}
                </div>
                <button
                  onClick={() => toggleCard("stlJobseeker")}
                className="text-[#fff] text-center hover:underline mt-3 font-medium md:text-lg text-md lg:text-lg "
                >
                  {expandedCards.stlJobseeker ? "Read Less" : "Read More"}
                </button>
                
              </div>
   
              <div 
            //  onClick={() => setIsMODOCModalOpen(true)} 
              className="bg-gray-300 text-[#003dA5] justify-center p-6">
                <h3 className="text-2xl font-bold text-center mb-4">MO-DOC Pre-Release Participants</h3>
                                <div className={`transition-all duration-500 ease-in-out ${expandedCards.modocJobseeker ? 'max-h-[2000px] opacity-100' : 'max-h-20 opacity-75'} overflow-hidden`}>
                  <p className="md:text-lg text-md lg:text-lg leading-relaxed mb-4 text-[#003DA5] font-['corporate-s']">
                    {expandedCards.modocJobseeker
                      ? "By engaging justice-involved jobseekers earlier, we can better prepare them for employment and reduce the stress of post-release job searching. Our video resume model allows participants to showcase their skills and readiness to employers before they leave incarceration, making the hiring process more seamless and efficient."
                      : "By engaging justice-involved jobseekers earlier, we can better prepare them for employment and reduce the stress of post-release job searching. Our video resume model allows participants to showcase their skills and readiness to employers before they leave incarceration, making the hiring process more seamless and efficient.".slice(0, 100) + "..."}
                  </p>
                  {expandedCards.modocJobseeker && (
                    <>
                      <div className="bg-white p-6 mb-4 rounded-lg shadow-sm">
                        <h4 className="md:text-lg text-md lg:text-xl font-bold mb-3 text-[#003DA5] font-['corporate-s']">
                          Partnership Facilities
                        </h4>
                        <p className="text-[#2b2b2b] mb-3 font-font-['corporate-s'] md:text-lg text-md lg:text-lg">
                          In partnership with the Missouri Department of
                          Corrections (MO DOC), SLU TWA works with jobseekers in
                          five correctional facilities, which include:
                        </p>
                        <div className="grid grid-cols-1 gap-2 md:text-lg text-md lg:text-lg font-['corporate-s']">
                          {[
                            "Bowling Green (NECC)",
                            "Farmington (FCC)",
                            "Pacific (MECC)",
                            "Vandalia (WERDCC)",
                            "Transition Center of St. Louis (TCSTL)",
                          ].map((facility, index) => (
                            <div key={index} className="flex items-center gap-2">
                              <MapPin className="w-4 h-4 text-[#53C3EE]" />
                              <span className="text-[#2b2b2b] md:text-lg text-md lg:text-lg">{facility}</span>
                            </div>
                          ))}
                        </div>
                        <p className="text-[#2b2b2b] mt-3 md:text-lg text-md lg:text-lg font-['corporate-s']">
                          This collaboration with MO DOC has offered TWA the
                          opportunity to expand and prepare participants in these
                          institutions who are heading home not only to the St.
                          Louis Metropolitan Area, but also to Kansas City,
                          Springfield, and Columbia, Missouri.
                        </p>
                      </div>

                      <div className="bg-white p-6 mb-4 shadow-sm">
                        <h4 className="md:text-lg text-md lg:text-xl font-bold mb-3  text-[#003DA5] font-['corporate-s']">
                          How we work together
                        </h4>
                        <p className="text-[#2b2b2b] mb-4 font-['corporate-s'] md:text-lg text-md lg:text-lg">
                          Jobseekers pre-release services begin 90-120 days before
                          release and then continue the process after they are
                          home, with follow-up available for the year after
                          release. Pre-release services are centered around
                          evidence-based curriculum, which teach successful
                          reentry practices with real world applications.
                        </p>
                        <div className="space-y-3 mb-4">
                          <div className="flex items-start gap-2">
                            <Clock className="w-5 h-5 text-blue-600 mt-1" />
                            <div>
                              <p className="font-semibold  text-[#003DA5] font-['corporate-s'] md:text-lg text-md lg:text-lg">
                                Pre-Release (90-120 days before release)
                              </p>
                              <p className="text-[#2b2b2b] md:text-lg text-md lg:text-lg">
                                Evidence-based curriculum teaching successful
                                reentry practices with real world applications
                              </p>
                            </div>
                          </div>
                          <div className="flex items-start gap-2">
                            <Target className="w-5 h-5 text-blue-600 mt-1" />
                            <div>
                              <p className="font-semibold  text-[#003DA5] font-['corporate-s'] md:text-lg text-md lg:text-lg">
                                Post-Release Services
                              </p>
                              <p className="text-[#2b2b2b] mb-2 font-['corporate-s'] md:text-lg text-md lg:text-lg">
                                Upon reentry it is the participants'
                                responsibility to contact the SLU TWA program and
                                arrange a meeting with an employment specialist.
                                Services include:
                              </p>
                              <ul className="space-y-1 md:text-lg text-md lg:text-lg font-['corporate-s']">
                                {jobseekerServices.map((service, index) => (
                                  <li
                                    key={index}
                                    className="flex items-start gap-2"
                                  >
                                    <div className="w-1.5 h-1.5 bg-blue-600 mt-1.5 flex-shrink-0"></div>
                                    <span className="text-[#2b2b2b">{service}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="bg-blue-50 p-6 rounded-lg shadow-sm">
                        <h4 className="md:text-lg text-md lg:text-xl font-bold mb-3  text-[#003DA5] font-['corporate-s']">
                          Find your region
                        </h4>
                        <p className="text-[#2b2b2b] mb-3 font-['corporate-s'] md:text-lg text-md lg:text-lg ">
                          In our expansion areas, as we establish our footprint in
                          those communities, we are currently only able to work
                          with participants who began services with us
                          pre-release.
                        </p>
                        <p className="text-gray-700 mb-3 font-['corporate-s'] md:text-lg text-md lg:text-lg ">
                          If you are a participant in the program and ready to
                          begin post-release work, please contact the SLU TWA
                          contact in your region:
                        </p>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                          {regions.map((region, index) => (
                            <Link
                              key={index}
                              to={region.contact}
                              className="text-[#003DA5] font-medium hover:underline md:text-lg text-md lg:text-lg  font-['corporate-s']"
                            >
                              {region.name}
                            </Link>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <button
                  onClick={() => toggleCard("modocJobseeker")}
                className="text-[#003DA5] hover:underline mt-3 font-medium md:text-lg text-md lg:text-lg "
                >
                  {expandedCards.modocJobseeker ? "Read Less" : "Read More"}
                </button>
              </div>
            </div>
          </div>
                      <div className="bg-white justify-center col-span-1 md:col-start-4 md:col-span-5 row-span-2 border-y-4 border-[#FFC72C] flex items-center">
              <p className="md:px-20 font-['corporate-s'] text-lg md:text-2xl lg:text-xl xl:text-2xl leading-relaxed text-[#2b2b2b]">
                We recognize that individuals with criminal records often face
                significant barriers to employment—even after they've paid their
                debt to society and are ready to move forward. At SLU TWA, we
                believe in the power of second chances.
              </p>
            </div>
            </div> */}
        </section>

        {/* Employers Section */}
        <section id="employers-section" className="py-16 bg-white">
          <div className="mx-auto max-w-7xl md:pr-20">
            <div className="grid grid-cols-1 md:grid-cols-6 justify-center gap-3">
              <div className="text-center col-span-1 md:col-start-2 md:col-span-5 justify-left flex flex-col sm:flex-row items-center py-10">
                <h2 className="text-5xl font-bold font-['corporate-s'] text-[#FFC72C]">
                  Employers
                </h2>
                <p className="text-lg md:text-3xl text-center leading-tight font-['farnham-display'] text-[#2b2b2b] md:pl-6 mt-2">
                  What does it mean to be a fair chance employer?
                </p>
              </div>
              {/* <div className="bg-[#f0f0f0] col-span-1 md:col-start-2 md:col-span-6 justify-center py-3">
              {/* Yellow Line *
              <div className="border-l-6  border-[#FFC72C] ml-6 pl-4 md:pr-20">
                {/* Content *
                <div className="font-['corporate-s'] text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed text-[#2b2b2b]">
                  <p>
                                       Being a Fair Chance Employer considers candidates based on their qualifications, 
                    experience, and potential — not solely on their past. It involves creating pathways
                    to employment for individuals who are committed to rebuilding their lives through 
                    meaningful work
                  </p>
                </div>
              </div>
            </div> */}
            </div>
          </div>
          <div className="grid py-8 px-0 place-items-center bg-[#ffff]">
            <div className="flex flex-col md:flex-row items-center gap-6 bg-[#f0f0f0] md:h-full">
              <div className="md:w-1/2 h-auto relative pr-2">
                {/* Image container (on the right on large screens) */}
                <img
                  src={work}
                  alt="Workforce Development"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Yellow Line + Text */}
              <div className="md:w-1/2 relative relative">
                <div className="pl-6 pt-10 pb-10">
                  <p className="text-base md:text-xl lg:text-md xl:text-xl text-left my-4 px-2 pr-2 font-['corporate-s'] leading-relaxed border-l-6 border-[#FFD700]">
                    Being a Fair Chance Employer considers candidates based on
                    their qualifications, experience, and potential — not solely
                    on their past. It involves creating pathways to employment
                    for individuals who are committed to rebuilding their lives
                    through meaningful work
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col md:px-20  px-0 space-y-8">
            {/* New / Aspiring Employer */}
            <div className="bg-[#003DA5] text-white p-6 rounded-lg">
              <h3 className="text-2xl font-bold text-center mb-4">
                New or Aspiring Employer
              </h3>

              <div
                className={`transition-all duration-500 ease-in-out overflow-hidden ${
                  expandedCards.newEmployer
                    ? "max-h-[4000px] opacity-100"
                    : "max-h-20 opacity-75"
                }`}
              >
                <p className="md:text-lg text-md lg:text-lg leading-relaxed mb-4 font-['corporate-s']">
                  {expandedCards.newEmployer
                    ? "Imagine unlocking a hidden talent pool filled by individuals who are ready to work and eager to prove themselves. Fair chance employment gives that opportunity—by focusing on qualifications, not past mistakes. It's a forward-thinking approach that helps business grow, strengthens community, and enhances a business's reputation as an inclusive, socially responsible employer. With proven benefits like higher retention rates and stronger employee loyalty, fair chance hiring isn't just the right thing to do—it's a smart business move. Now's the time to lead with purpose and open the door to second or fair chances."
                    : "Imagine unlocking a hidden talent pool filled by individuals who are ready to work and eager to prove themselves. Fair chance employment gives that opportunity—by focusing on qualifications, not past mistakes. It's a forward-thinking approach that helps business grow, strengthens community, and enhances a business's reputation as an inclusive, socially responsible employer. With proven benefits like higher retention rates and stronger employee loyalty, fair chance hiring isn't just the right thing to do—it's a smart business move. Now's the time to lead with purpose and open the door to second or fair chances."
                        .slice
                        // 0,
                        // 120
                        () + "..."}
                </p>

                {expandedCards.newEmployer && (
                  <>
                    {/* What, Why, How Section */}
                    <div className="bg-white p-5 ">
                      <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s'] mb-4">
                        The What, Why and How Fair Chance Employment Works
                      </h4>

                      <div className="mb-5">
                        <h5 className="md:text-lg text-md lg:text-lg font-bold text-[#003DA5] font-['corporate-s'] mb-2">
                          Why Fair Chance Hiring Matters
                        </h5>
                        <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s'] mb-3">
                          Every year, thousands of capable individuals are
                          overlooked because of a past conviction. Yet many of
                          these individuals are highly motivated, skilled, and
                          eager to contribute. By implementing fair hiring
                          practices, employers can help break the cycle of
                          recidivism, strengthen their workforce, and contribute
                          to safer, more inclusive communities.
                        </p>
                        <div className="bg-[#003DA5] text-white p-3 text-center font-bold md:text-lg text-md lg:text-xl rounded-md">
                          Fair chance hiring is more than a gesture of
                          goodwill—it's a smart, strategic investment in people.
                        </div>
                      </div>

                      <div>
                        <h5 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s'] mb-3">
                          Key Principles of Fair Chance Employment
                        </h5>
                        <div className="space-y-3">
                          {[
                            "Delay background checks until later in the hiring process, allowing candidates to be evaluated on merit first (commonly known as 'Ban the Box').",
                            "Assess each applicant individually, considering the nature and age of the offense, and its relevance to the job.",
                            "Foster a workplace culture that values growth, accountability, and second chances.",
                          ].map((principle, i) => (
                            <div key={i} className="flex items-start gap-2">
                              <div className="w-2 h-2 bg-[#003DA5] rounded-full mt-1.5 flex-shrink-0"></div>
                              <p className="md:text-lg text-md lg:text-lg text-gray-700 font-['corporate-s']">
                                {principle}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Benefits Section */}
                    <div className="bg-[#fff] p-5 mb-4">
                      <h4 className="md:text-lg text-md lg:text-xl  font-bold text-[#003DA5] font-['corporate-s'] mb-3">
                        Benefits to Employers
                      </h4>
                      <p className="md:text-lg text-md lg:text-lg  text-[#003DA5] font-['corporate-s'] mb-4">
                        Choosing to become a Fair Chance Employer not only helps
                        individuals reenter the workforce — it also brings
                        tangible benefits to your business:
                      </p>
                      <div className="space-y-3">
                        {enhancedBenefits.map((benefit, index) => (
                          <div
                            key={index}
                            className="flex items-start gap-3 p-4 bg-white"
                          >
                            <div className="text-[#003DA5]">{benefit.icon}</div>
                            <div>
                              <h5 className="md:text-lg text-md lg:text-lg  font-bold text-[#003DA5] font-['corporate-s'] mb-1">
                                {benefit.title}
                              </h5>
                              <p className="md:text-lg text-md lg:text-lg  text-gray-600 font-['corporate-s']">
                                {benefit.description}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Video Platform Section */}
                    {/* <div className="bg-[#fff] p-5">
                      <div className="flex items-center gap-2 mb-3">
                        <Video className="w-6 h-6 text-[#003DA5]" />
                        <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s']">
                          Access to Faces of Talent Platform, SLU TWA's custom video resume platform
                        </h4>
                      </div>
                      <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s'] mb-3">
                        SLU TWA's innovative custom Faces of Talent  platform, Faces of Talent 
                        Platform is built exclusively for fair chance employers
                        looking to grow their talent pool with purpose and ease.
                      </p>
                      <div className="bg-gray-100 p-3 mb-4 rounded-lg">
                        <p className="font-bold text-[#003DA5] md:text-lg text-md lg:text-lg  font-['corporate-s']">
                          It's a game-changing tool that saves time, and
                          strengthens teams with individuals committed to a
                          fresh start.
                        </p>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                        <div className="bg-gray-100 p-3 rounded-lg">
                          <h5 className="font-bold md:text-lg text-md lg:text-lg text-[#003DA5] font-['corporate-s'] mb-2">
                            What are the benefits?
                          </h5>
                          <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s']">
                            Designed to streamline the hiring process, the
                            platform is organized by industry and region,
                            allowing employers to quickly access 2–3 minute
                            videos of justice-involved jobseekers who are ready
                            to work. These short videos go beyond resumes,
                            highlighting the human side of each candidate—their
                            personality, motivation, and readiness.
                          </p>
                        </div>
                        <div className="bg-gray-100 p-3 rounded-lg">
                          <h5 className="font-bold md:text-lg text-md lg:text-lg  text-[#003DA5] font-['corporate-s'] mb-2">
                            How will I use this platform?
                          </h5>
                          <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s']">
                            Employers will create custom profiles to filter
                            candidates based on industry, qualifications, and
                            job requirements, making it easier than ever to find
                            the right fit. By combining smart search features
                            with powerful storytelling, this platform helps
                            employers discover skilled, overlooked talent.
                          </p>
                        </div>
                      </div>

                      <button
                        className="w-full sm:w-auto bg-[#003DA5] text-white px-6 py-2.5 rounded-lg font-bold md:text-lg text-md lg:text-lg  transition-colors hover:bg-[#002b7a]"
                        onClick={() => {navigate("/video-platform/videos")
                        window.scrollTo(0, 0);}}
                      >
                        Access Video Platform
                      </button>
                    </div> */}
                  </>
                )}
              </div>

              <button
                onClick={() => toggleCard("newEmployer")}
                className="block  text-center text-white hover:underline mt-4 font-medium md:text-lg text-md lg:text-lg "
              >
                {expandedCards.newEmployer ? "Read Less" : "Read More"}
              </button>
            </div>

            {/* Existing Employer */}
            <div className="bg-gray-300 text-[#003DA5] p-6 rounded-lg">
              <h3 className="text-2xl font-bold text-center mb-4">
                Existing Employer
              </h3>

              <div
                className={`transition-all duration-500 ease-in-out overflow-hidden ${
                  expandedCards.existingEmployer
                    ? "max-h-[2500px] opacity-100"
                    : "max-h-20 opacity-75"
                }`}
              >
                <p className="md:text-lg text-md lg:text-lg leading-relaxed mb-4 font-['corporate-s']">
                  {expandedCards.existingEmployer
                    ? "By continuing to offer second chances, our employers are not just transforming lives—they're building a stronger, more resilient workforce and setting a powerful example of leadership and equity. The impact proves that talent and potential aren't defined by past mistakes. Staying the course means reinforcing company values, deepening employee loyalty, and continuing to tap into a dedicated, often overlooked talent pool. Fair chance hiring isn't just a policy—it's a long-term investment in people, business success, and lasting community change. SLU TWA is grateful for all of our employer partnerships and commitment to transforming the workforce."
                    : "By continuing to offer second chances, our employers are not just transforming lives—they're building a stronger, more resilient workforce and setting a powerful example of leadership and equity. The impact proves that talent and potential aren't defined by past mistakes. Staying the course means reinforcing company values, deepening employee loyalty, and continuing to tap into a dedicated, often overlooked talent pool. Fair chance hiring isn't just a policy—it's a long-term investment in people, business success, and lasting community change. SLU TWA is grateful for all of our employer partnerships and commitment to transforming the workforce."
                        .slice
                        // 0,
                        // 120
                        () + "..."}
                </p>

                {expandedCards.existingEmployer && (
                  <>
                    <div className="bg-white p-5">
                      <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s'] mb-3">
                        Fair Employer Training and Consultation
                      </h4>
                      <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
                        TWA offers individual consultations as well as group
                        trainings on the how's and why's of fair chance
                        employment in each service area in Missouri. Once
                        employers discuss their talent needs with TWA, they can
                        become an employer partner.
                      </p>
                    </div>

                    {/* Video Platform Section (Existing) */}
                    {/* <div className="bg-[#fff] p-5">
                      <div className="flex items-center gap-2 mb-3">
                        <Video className="w-6 h-6 text-[#003DA5]" />
                        <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s']">
                          Access to Faces of Talent  Platform, SLU TWA's custom video
                          resume platform
                        </h4>
                      </div>
                      <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s'] mb-3">
                        SLU TWA's innovative custom Faces of Talent  platform, Faces of Talent 
                        Platform is built exclusively for fair chance employers
                        looking to grow their talent pool with purpose and ease.
                      </p>
                      <div className="bg-gray-100 p-3 mb-4 rounded-lg">
                        <p className="font-bold text-[#003DA5] md:text-lg text-md lg:text-lg font-['corporate-s']">
                          It's a game-changing tool that saves time, and
                          strengthens teams with individuals committed to a
                          fresh start.
                        </p>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                        <div className="bg-gray-100 p-3 rounded-lg">
                          <h5 className="font-bold md:text-lg text-md lg:text-lg text-[#003DA5] font-['corporate-s'] mb-2">
                            What are the benefits?
                          </h5>
                          <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
                            Designed to streamline the hiring process, the
                            platform is organized by industry and region,
                            allowing employers to quickly access 2–3 minute
                            videos of justice-involved jobseekers who are ready
                            to work.
                          </p>
                        </div>
                        <div className="bg-gray-100 p-3 rounded-lg">
                          <h5 className="font-bold md:text-lg text-md lg:text-lg text-[#003DA5] font-['corporate-s'] mb-2">
                            How will I use this platform?
                          </h5>
                          <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
                            Employers will create custom profiles to filter
                            candidates based on industry, qualifications, and
                            job requirements, making it easier than ever to find
                            the right fit.
                          </p>
                        </div>
                      </div>

                      <button
                        className="w-full sm:w-auto bg-[#003DA5] text-white px-6 py-2.5 rounded-lg font-bold md:text-lg text-md lg:text-lg transition-colors hover:bg-[#002b7a]"
                        onClick={() => {navigate("/video-platform/videos")
                         window.scrollTo(0, 0);} 
                        }
                      >
                        Access Faces of Talent  Platform
                      </button>
                    </div> */}

                    <Link
                      to="/contact"
                      className="inline-flex items-center justify-center mt-10 gap-2 w-full sm:w-auto bg-[#003DA5] text-white px-4 py-2.5 md:text-lg text-md lg:text-lg font-medium transition-colors hover:bg-[#002b7a] rounded-lg"
                    >
                      <Mail className="w-4 h-4" />
                      Contact Us
                    </Link>
                  </>
                )}
              </div>

              <button
                onClick={() => toggleCard("existingEmployer")}
                className="block text-center text-[#003DA5] hover:underline mt-4 font-medium md:text-lg text-md lg:text-lg"
              >
                {expandedCards.existingEmployer ? "Read Less" : "Read More"}
              </button>
            </div>

            {/* Video Platform Section */}
            {/* <div className="bg-[#E3DECB] p-5 rounded-lg">
              <div className="flex items-center gap-2 mb-3">
                <Video className="w-6 h-6 text-[#003DA5]" />
                <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s']">
                  Access to Faces of Talent, SLU TWA's custom platform
                </h4>
              </div>
              <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s'] mb-3">
                SLU TWA's innovative custom Faces of Talent platform, Faces of
                Talent Platform is built exclusively for fair chance employers
                looking to grow their talent pool with purpose and ease.
              </p>
              <div className="bg-gray-100 p-3 mb-4 rounded-lg">
                <p className="font-bold text-[#003DA5] md:text-lg text-md lg:text-lg  font-['corporate-s']">
                  It's a game-changing tool that saves time, and strengthens
                  teams with individuals committed to a fresh start.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                <div className="bg-gray-100 p-3 rounded-lg">
                  <h5 className="font-bold md:text-lg text-md lg:text-lg text-[#003DA5] font-['corporate-s'] mb-2">
                    What are the benefits?
                  </h5>
                  <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s']">
                    Designed to streamline the hiring process, the platform is
                    organized by industry and region, allowing employers to
                    quickly access 2–3 minute videos of justice-involved
                    jobseekers who are ready to work. These short videos go
                    beyond resumes, highlighting the human side of each
                    candidate—their personality, motivation, and readiness.
                  </p>
                </div>
                <div className="bg-gray-100 p-3 rounded-lg">
                  <h5 className="font-bold md:text-lg text-md lg:text-lg  text-[#003DA5] font-['corporate-s'] mb-2">
                    How will I use this platform?
                  </h5>
                  <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s']">
                    Employers will create custom profiles to filter candidates
                    based on industry, qualifications, and job requirements,
                    making it easier than ever to find the right fit. By
                    combining smart search features with powerful storytelling,
                    this platform helps employers discover skilled, overlooked
                    talent.
                  </p>
                </div>
              </div>

              <button
                className="w-full sm:w-auto bg-[#003DA5] text-white px-6 py-2.5 rounded-lg font-bold md:text-lg text-md lg:text-lg  transition-colors hover:bg-[#002b7a]"
                onClick={() => {
                  navigate("/video-platform/videos");
                  window.scrollTo(0, 0);
                }}
              >
                Access Faces of Talent Platform
              </button>
            </div> */}

            {/* <div className="col-span-1 md:col-start-1 md:col-span-7 justify-center mt-20">
              <div className="relative w-full bg-[#003DA5] rounded-lg overflow-hidden">
                <div className="grid grid-cols-1 md:grid-cols-3 items-stretch">
                  <img
                    src={people}
                    alt="Faces of Talent Platform"
                    className="md:col-start-1 w-full h-full object-cover min-h-[300px]"
                  />

                  <div className="md:col-span-2 p-4 md:p-4 text-white flex flex-col justify-center font-['corporate-s']">
                    <div className="flex items-center mb-6">
                      <img
                        src={Logo}
                        alt="Faces of Talent Platform Logo"
                        className="w-full max-w-[3/4] h-auto object-contain"
                        loading="lazy"
                      />
                    </div>

                    <p className="text-md md:text-lg leading-relaxed mb-4 text-white/90">
                      SLU TWA’s innovative Faces of Talent platform is built
                      exclusively for fair chance employers looking to grow
                      their talent pool with purpose and ease.
                    </p>

                    <div className="bg-white/10 p-4 rounded-lg mb-6">
                      <p className="font-semibold text-[#FFC72C] text-lg md:text-2xl">
                        A game-changing tool that saves time and strengthens
                        teams with individuals committed to a fresh start.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                      <div className="bg-white/10 p-4 rounded-lg">
                        <h5 className="font-bold text-[#FFC72C] text-md md:text-lg mb-2">
                          What are the benefits?
                        </h5>
                        <p className="text-white/90 text-sm md:text-base leading-relaxed">
                          Designed to streamline the hiring process, the
                          platform is organized by industry and region.
                          Employers can quickly access 2–3 minute videos
                          showcasing justice-involved jobseekers beyond resumes
                          — highlighting motivation, personality, and readiness.
                        </p>
                      </div>

                      <div className="bg-white/10 p-4 rounded-lg">
                        <h5 className="font-bold text-[#FFC72C] text-md md:text-lg mb-2">
                          How will I use this platform?
                        </h5>
                        <p className="text-white/90 text-sm md:text-base leading-relaxed">
                          Employers create custom profiles to filter candidates
                          by industry, qualifications, and job needs. Powerful
                          search plus authentic storytelling helps uncover
                          skilled, overlooked talent.
                        </p>
                      </div>
                    </div>
                    <div>
                      <button
                        className="bg-[#FFC72C] text-[#003DA5] px-6 py-3 rounded-lg font-bold text-md md:text-lg hover:bg-[#ffcc00] transition-colors w-full sm:w-auto"
                        onClick={() => {
                          navigate("/video-platform/regions");
                          window.scrollTo(0, 0);
                        }}
                      >
                        Access Faces of Talent Platform
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-span-1 md:col-start-1 md:col-span-7 justify-center mt-20">
              <div className="relative w-full bg-[#003DA5] rounded-lg overflow-hidden">
                <div className="grid grid-cols-1 md:grid-cols-12 items-stretch">
                  {/* Image */}
                  <img
                    src={people}
                    alt="Faces of Talent Platform"
                    className="md:col-span-5 w-full h-full object-cover min-h-[400px]"
                  />

                  {/* Content */}
                  <div className="md:col-span-7 p-6 md:p-10 text-white flex flex-col justify-center font-['corporate-s']">
                    {/* Logo */}
                    <div className="flex justify-center mb-6">
                      <img
                        src={Logo}
                        alt="Faces of Talent Platform Logo"
                        className="w-full max-w-full h-auto object-contain"
                        loading="lazy"
                      />
                    </div>

                    <p className="text-md md:text-lg leading-relaxed mb-4 text-white/90">
                      SLU TWA’s innovative Faces of Talent platform is built
                      exclusively for fair chance employers looking to grow
                      their talent pool with purpose and ease.
                    </p>

                    <div className="bg-white/10 p-4 rounded-lg mb-6">
                      <p className="font-semibold text-[#FFC72C] text-lg md:text-2xl">
                        A game-changing tool that saves time and strengthens
                        teams with individuals committed to a fresh start.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                      <div className="bg-white/10 p-4 rounded-lg">
                        <h5 className="font-bold text-[#FFC72C] text-md md:text-lg mb-2">
                          What are the benefits?
                        </h5>
                        <p className="text-white/90 text-sm md:text-base leading-relaxed">
                          Designed to streamline the hiring process, the
                          platform is organized by industry and region, allowing
                          employers to quickly access 2–3 minute videos of
                          justice-involved jobseekers who are ready to work.
                          These short videos go beyond resumes, highlighting the
                          human side of each candidate—their personality,
                          motivation, and readiness.
                        </p>
                      </div>

                      <div className="bg-white/10 p-4 rounded-lg">
                        <h5 className="font-bold text-[#FFC72C] text-md md:text-lg mb-2">
                          How will I use this platform?
                        </h5>
                        <p className="text-white/90 text-sm md:text-base leading-relaxed">
                          Employers will create custom profiles to filter
                          candidates based on industry, qualifications, and job
                          requirements, making it easier than ever to find the
                          right fit. By combining smart search features with
                          powerful storytelling, this platform helps employers
                          discover skilled, overlooked talent.
                        </p>
                      </div>
                    </div>

                    <button
                      className="bg-[#FFC72C] text-[#003DA5] px-6 py-3 rounded-lg font-bold text-md md:text-lg hover:bg-[#ffcc00] transition-colors w-full sm:w-auto"
                      onClick={() => {
                        navigate("/video-platform/regions");
                        window.scrollTo(0, 0);
                      }}
                    >
                      Access Faces of Talent Platform
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start px-4 py-8"> */}
        {/* Left Column - Image */}
        {/* <div className="flex items-center justify-center h-full">
    <img
      src={work}
      alt="Workforce Development"
      className="w-full h-full max-h-auto md:max-h-full object-cover shadow-md" //changed height from 116 to full to cover entire page when clicked read more
    />
  </div> */}

        {/* Right Column - Employer Options */}
        {/* <div className="flex flex-col gap-6 h-full">
         */}
        {/* New / Aspiring Employer */}
        {/* <div className="bg-[#003DA5] text-white p-6">
      <h3 className="text-2xl font-bold text-center mb-4">
        New or Aspiring Employer
      </h3>

      <div
        className={`transition-all duration-500 ease-in-out overflow-hidden ${
          expandedCards.newEmployer ? 'max-h-[3000px] opacity-100' : 'max-h-20 opacity-75'
        }`}
      >
        <p className="md:text-lg text-md lg:text-lg leading-relaxed mb-4 font-['corporate-s']">
          {expandedCards.newEmployer
            ? "Imagine unlocking a hidden talent pool filled by individuals who are ready to work and eager to prove themselves. Fair chance employment gives that opportunity—by focusing on qualifications, not past mistakes. It's a forward-thinking approach that helps business grow, strengthens community, and enhances a business's reputation as an inclusive, socially responsible employer. With proven benefits like higher retention rates and stronger employee loyalty, fair chance hiring isn't just the right thing to do—it's a smart business move. Now's the time to lead with purpose and open the door to second or fair chances."
            : "Imagine unlocking a hidden talent pool filled by individuals who are ready to work and eager to prove themselves. Fair chance employment gives that opportunity—by focusing on qualifications, not past mistakes. It's a forward-thinking approach that helps business grow, strengthens community, and enhances a business's reputation as an inclusive, socially responsible employer. With proven benefits like higher retention rates and stronger employee loyalty, fair chance hiring isn't just the right thing to do—it's a smart business move. Now's the time to lead with purpose and open the door to second or fair chances.".slice(
                0,
                120
              ) + "..."}
        </p>

        {expandedCards.newEmployer && (
          <>
            {/* What, Why, How Section *
            <div className="bg-white p-5 mb-4 rounded-lg shadow-sm">
              <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s'] mb-4">
                The What, Why and How Fair Chance Employment Works
              </h4>

              <div className="mb-5">
                <h5 className="md:text-lg text-md lg:text-lg font-bold text-[#003DA5] font-['corporate-s'] mb-2">
                  Why Fair Chance Hiring Matters
                </h5>
                <p className="md:text-lg text-md lg:text-lg text-gray-700 font-['corporate-s'] mb-3">
                  Every year, thousands of capable individuals are overlooked because of a past conviction. Yet many of
                  these individuals are highly motivated, skilled, and eager to contribute. By implementing fair hiring
                  practices, employers can help break the cycle of recidivism, strengthen their workforce, and contribute
                  to safer, more inclusive communities.
                </p>
                <div className="bg-[#003DA5] text-white p-3 text-center font-bold md:text-lg text-md lg:text-xl rounded-md">
                  Fair chance hiring is more than a gesture of goodwill—it's a smart, strategic investment in people.
                </div>
              </div>

              <div>
                <h5 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s'] mb-3">
                  Key Principles of Fair Chance Employment
                </h5>
                <div className="space-y-3">
                  {[
                    "Delay background checks until later in the hiring process, allowing candidates to be evaluated on merit first (commonly known as 'Ban the Box').",
                    "Assess each applicant individually, considering the nature and age of the offense, and its relevance to the job.",
                    "Foster a workplace culture that values growth, accountability, and second chances.",
                  ].map((principle, i) => (
                    <div key={i} className="flex items-start gap-2">
                      <div className="w-2 h-2 bg-[#53C3EE] rounded-full mt-1.5 flex-shrink-0"></div>
                      <p className="md:text-lg text-md lg:text-lg text-gray-700 font-['corporate-s']">{principle}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Benefits Section *
            <div className="mb-4">
              <h4 className="md:text-lg text-md lg:text-xl  font-bold text-white font-['corporate-s'] mb-3">
                Benefits to Employers
              </h4>
              <p className="md:text-lg text-md lg:text-lg  text-white font-['corporate-s'] mb-4">
                Choosing to become a Fair Chance Employer not only helps individuals reenter the workforce — it also
                brings tangible benefits to your business:
              </p>
              <div className="space-y-3">
                {enhancedBenefits.map((benefit, index) => (
                  <div key={index} className="flex items-start gap-3 p-4 bg-white rounded-lg shadow-sm">
                    <div className="text-[#53C3EE]">{benefit.icon}</div>
                    <div>
                      <h5 className="md:text-lg text-md lg:text-lg  font-bold text-[#003DA5] font-['corporate-s'] mb-1">
                        {benefit.title}
                      </h5>
                      <p className="md:text-lg text-md lg:text-lg  text-gray-600 font-['corporate-s']">{benefit.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Video Platform Section *
            <div className="bg-[#f0f0f0] p-5 rounded-lg shadow-sm">
              <div className="flex items-center gap-2 mb-3">
                <Video className="w-6 h-6 text-[#003DA5]" />
                <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s'] mb-4">
                  Access to Video Platform, SLU TWA's custom video resume platform
                </h4>
              </div>
              <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s'] mb-3">
                SLU TWA's innovative custom video platform, Video Platform is built exclusively for fair chance
                employers looking to grow their talent pool with purpose and ease.
              </p>
              <div className="bg-gray-100 p-3 mb-4 rounded-lg">
                <p className="font-bold text-[#003DA5] md:text-lg text-md lg:text-lg  font-['corporate-s']">
                  It's a game-changing tool that saves time, and strengthens teams with individuals committed to a
                  fresh start.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                <div className="bg-gray-100 p-3 rounded-lg">
                  <h5 className="font-bold md:text-lg text-md lg:text-lg text-[#003DA5] font-['corporate-s'] mb-2">
                    What are the benefits?
                  </h5>
                  <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s']">
                    Designed to streamline the hiring process, the platform is organized by industry and region,
                    allowing employers to quickly access 2–3 minute videos of justice-involved jobseekers who are ready
                    to work. These short videos go beyond resumes, highlighting the human side of each candidate—their
                    personality, motivation, and readiness.
                  </p>
                </div>
                <div className="bg-gray-100 p-3 rounded-lg">
                  <h5 className="font-bold md:text-lg text-md lg:text-lg  text-[#003DA5] font-['corporate-s'] mb-2">
                    How will I use this platform?
                  </h5>
                  <p className="md:text-lg text-md lg:text-lg  text-gray-700 font-['corporate-s']">
                    Employers will create custom profiles to filter candidates based on industry, qualifications, and
                    job requirements, making it easier than ever to find the right fit. By combining smart search
                    features with powerful storytelling, this platform helps employers discover skilled, overlooked
                    talent.
                  </p>
                </div>
              </div>

              <button
                className="w-full sm:w-auto bg-[#003DA5] text-white px-6 py-2.5 rounded-lg font-bold md:text-lg text-md lg:text-lg  transition-colors hover:bg-[#002b7a]"
                onClick={() => navigate("/video-platform/videos")}
              >
                Access Video Platform
              </button>
            </div>
          </>
        )}
      </div>

      <button
        onClick={() => toggleCard("newEmployer")}
        className="block  text-center text-white hover:underline mt-4 font-medium md:text-lg text-md lg:text-lg "
      >
        {expandedCards.newEmployer ? "Read Less" : "Read More"}
      </button>
    </div>

    {/* Existing Employer *
    <div className="bg-gray-300 text-[#003DA5] p-6">
      <h3 className="text-2xl font-bold text-center mb-4">Existing Employer</h3>

      <div
        className={`transition-all duration-500 ease-in-out overflow-hidden ${
          expandedCards.existingEmployer ? 'max-h-[2500px] opacity-100' : 'max-h-20 opacity-75'
        }`}
      >
        <p className="md:text-lg text-md lg:text-lg leading-relaxed mb-4 font-['corporate-s']">
          {expandedCards.existingEmployer
            ? "By continuing to offer second chances, our employers are not just transforming lives—they're building a stronger, more resilient workforce and setting a powerful example of leadership and equity. The impact proves that talent and potential aren't defined by past mistakes. Staying the course means reinforcing company values, deepening employee loyalty, and continuing to tap into a dedicated, often overlooked talent pool. Fair chance hiring isn't just a policy—it's a long-term investment in people, business success, and lasting community change. SLU TWA is grateful for all of our employer partnerships and commitment to transforming the workforce."
            : "By continuing to offer second chances, our employers are not just transforming lives—they're building a stronger, more resilient workforce and setting a powerful example of leadership and equity. The impact proves that talent and potential aren't defined by past mistakes. Staying the course means reinforcing company values, deepening employee loyalty, and continuing to tap into a dedicated, often overlooked talent pool. Fair chance hiring isn't just a policy—it's a long-term investment in people, business success, and lasting community change. SLU TWA is grateful for all of our employer partnerships and commitment to transforming the workforce.".slice(
                0,
                120
              ) + "..."}
        </p>

        {expandedCards.existingEmployer && (
          <>
            <div className="bg-white p-5 mb-4 rounded-lg shadow-sm">
              <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['HVD_Trial_Brandon_Grotesque'] mb-3">
                Fair Employer Training and Consultation
              </h4>
              <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
                TWA offers individual consultations as well as group trainings on the how's and why's of fair chance
                employment in each service area in Missouri. Once employers discuss their talent needs with TWA, they
                can become an employer partner.
              </p>
            </div>

            {/* Video Platform Section (Existing) *
            <div className="bg-[#f0f0f0] p-5 rounded-lg shadow-sm mb-4">
              <div className="flex items-center gap-2 mb-3">
                <Video className="w-6 h-6 text-[#003DA5]" />
                <h4 className="md:text-lg text-md lg:text-xl font-bold text-[#003DA5] font-['corporate-s'] mb-4">
                  Access to Video Platform, SLU TWA's custom video resume platform
                </h4>
              </div>
              <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s'] mb-3">
                SLU TWA's innovative custom video platform, Video Platform is built exclusively for fair chance
                employers looking to grow their talent pool with purpose and ease.
              </p>
              <div className="bg-gray-100 p-3 mb-4 rounded-lg">
                <p className="font-bold text-[#003DA5] md:text-lg text-md lg:text-lg font-['corporate-s']">
                  It's a game-changing tool that saves time, and strengthens teams with individuals committed to a
                  fresh start.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                <div className="bg-gray-100 p-3 rounded-lg">
                  <h5 className="font-bold md:text-lg text-md lg:text-lg text-[#003DA5] font-['corporate-s'] mb-2">
                    What are the benefits?
                  </h5>
                  <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
                    Designed to streamline the hiring process, the platform is organized by industry and region,
                    allowing employers to quickly access 2–3 minute videos of justice-involved jobseekers who are ready
                    to work.
                  </p>
                </div>
                <div className="bg-gray-100 p-3 rounded-lg">
                  <h5 className="font-bold md:text-lg text-md lg:text-lg text-[#003DA5] font-['corporate-s'] mb-2">
                    How will I use this platform?
                  </h5>
                  <p className="md:text-lg text-md lg:text-lg text-[#2b2b2b] font-['corporate-s']">
                    Employers will create custom profiles to filter candidates based on industry, qualifications, and
                    job requirements, making it easier than ever to find the right fit.
                  </p>
                </div>
              </div>

              <button
                className="w-full sm:w-auto bg-[#003DA5] text-white px-6 py-2.5 rounded-lg font-bold md:text-lg text-md lg:text-lg transition-colors hover:bg-[#002b7a]"
                onClick={() => navigate("/video-platform/videos")}
              >
                Access Video Platform
              </button>
            </div>

            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto bg-[#003DA5] text-white px-4 py-2.5 md:text-lg text-md lg:text-lg font-medium transition-colors hover:bg-[#002b7a]"
            >
              <Mail className="w-4 h-4" />
              Contact Us
            </Link>
          </>
        )}
      </div>

      <button
        onClick={() => toggleCard("existingEmployer")}
        className="block text-center text-[#003DA5] hover:underline mt-4 font-medium md:text-lg text-md lg:text-lg"
      >
        {expandedCards.existingEmployer ? "Read Less" : "Read More"}
      </button>
    </div>
  </div>
</div> 
      </section>*/}

        {/* Partners Section */}
        <section id="partners-section" className="bg-white">
          <div className="mx-auto max-w-7xl md:pr-20">
            <div className="grid grid-cols-1 md:grid-cols-6 justify-center gap-3">
              <div className="text-center col-span-1 md:col-start-2 md:col-span-5 justify-left flex flex-col sm:flex-row items-center py-3 gap-6">
                <h2 className="text-5xl font-bold font-['corporate-s'] text-[#668ac9]">
                  Partners
                </h2>
                <p
                  className="text-xl md:text-3xl text-center leading-tight font-['farnham-display'] text-[#2b2b2b]
                 mt-2"
                >
                  Are you a STL community partner referring a jobseeker?
                </p>
              </div>
              <div className="bg-[#f0f0f0] col-span-1 md:col-start-2 md:col-span-6 bg-[#f0f0f0] p-6 mt-6">
                {/* Yellow Line */}
                <div className="border-l-6 border-[#FFC72C] pl-6">
                  {/* Content */}
                  <div className="font-['corporate-s'] text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed text-[#2b2b2b]">
                    <p>
                      We review new referrals every Monday to give them a
                      projected timeline of when we are available to assist if
                      we cannot work with someone immediately.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* {isModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div
                  className="absolute inset-0 bg-gray-100 bg-opacity-75"
                  onClick={() => setIsModalOpen(false)}
                />
                <div className="relative bg-white p-8 max-w-lg w-full mx-4 shadow-2xl">
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                    aria-label="Close modal"
                  >
                    ✕
                  </button>
                  <div className="bg-gray-50 p-6 sm:p-8 shadow-md">
                    <HandHeart className="w-10 h-10 text-[#00244D] mx-auto mb-6" />
                    <h3 className="text-2xl sm:text-3xl font-bold mb-6 text-[#00244D]">
                      Partner with Us
                    </h3>

                    <div className="bg-white p-6 mb-6 shadow-sm">
                      <div className="flex items-center gap-2 mb-4 justify-center">
                        <Phone className="w-5 h-5 text-[#00244D]" />
                        <span className="font-bold text-[#00244D] text-lg">
                          How to Refer
                        </span>
                      </div>
                      <p className="text-gray-700 mb-3 text-sm sm:text-base font-['corporate-s']">
                        Individuals may enter their information on the wait list
                        or call and leave a message at:
                      </p>
                      <div className="bg-[#EDEEF0] p-3 mb-3">
                        <p className="text-lg font-bold text-[#00244D]">
                          314-977-5498
                        </p>
                      </div>
                      <p className="text-gray-600 font-['corporate-s'] text-sm">
                        We review new referrals every Monday to give them a
                        projected timeline of when we are available to assist if
                        we cannot work with someone immediately.
                      </p>
                    </div>

                    <Link
                      to="/contact#st-louis"
                      className="inline-flex items-center gap-2 bg-[#00244D] text-white px-6 py-3 font-bold transition-colors text-sm sm:text-base"
                    >
                      <Mail className="w-5 h-5" />
                      Contact Our STL Team
                    </Link>
                  </div>
                </div>
              </div>
            )} */}

            {isModalOpen && (
              <div
                aria-modal="true"
                role="dialog"
                className="fixed inset-0 z-50 flex items-center justify-center p-6"
              >
                {/* Overlay */}
                <div
                  className="fixed inset-0 bg-black/50"
                  onClick={() => setIsModalOpen(false)}
                />

                {/* Modal Card */}
                <div className="relative bg-white max-w-lg w-full rounded-xl p-6 shadow-lg z-10">
                  {/* Close */}
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="absolute top-3 right-3 text-gray-500 cursor-pointer hover:text-gray-800"
                    aria-label="Close modal"
                  >
                    ✕
                  </button>

                  {/* Content */}
                  <div className="text-center">
                    <HandHeart className="w-12 h-12 text-[#00244D] mx-auto mb-4" />

                    <h3 className="text-2xl sm:text-3xl font-bold mb-6 text-[#00244D] font-['corporate-s']">
                      Partner with Us
                    </h3>

                    {/* Info Box */}
                    <div className="bg-gray-50 p-6 rounded-lg shadow-sm mb-6 text-left">
                      <div className="flex items-center justify-center gap-2 mb-4">
                        <Phone className="w-5 h-5 text-[#00244D]" />
                        <span className="font-bold text-[#00244D] text-lg">
                          How to Refer
                        </span>
                      </div>

                      <p className="text-gray-700 mb-3 text-sm sm:text-base font-['corporate-s']">
                        Individuals may enter their information on the wait list
                        or call and leave a message at:
                      </p>

                      <div className="bg-[#EDEEF0] p-3 mb-3 rounded-md text-center">
                        <p className="text-lg font-bold text-[#00244D]">
                          314-977-5498
                        </p>
                      </div>

                      <p className="text-gray-600 text-sm font-['corporate-s']">
                        We review new referrals every Monday and provide a
                        projected timeline if immediate assistance is
                        unavailable.
                      </p>
                    </div>

                    {/* CTA */}
                    <Link
                      to="/contact#st-louis"
                      className="inline-flex items-center justify-center gap-2 w-full px-6 py-3 bg-[#00244D] text-white rounded-lg font-bold transition-colors hover:bg-[#003DA5] font-['corporate-s']"
                    >
                      <Mail className="w-5 h-5" />
                      Contact Our STL Team
                    </Link>
                  </div>
                </div>
              </div>
            )}

            <div className="flex flex-col sm:flex-row justify-center md:justify-end gap-4 my-10 px-8 md:pr-8 md:ml-[304px]">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-[#003DA5] text-white font-bold p-6 "
              >
                Partner with Us
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-[#FFC72C] text-white font-bold p-6"
              >
                How to Refer
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default WhoWeServe;
